import { useState } from "react";
import { excelDespathDateOrdersClientByMonthAndYearEvent } from "../../_events/departures/find_departures.event";
import { message } from "antd";
import { downloadExcelFile } from "../../_utils/download_file.util";

export const useDownloadExcelDespathClientsDate = () => {

    const [ loading, setLoading ] = useState(false);

    const downloadExcel = (month, year) => {
        setLoading(true);
        excelDespathDateOrdersClientByMonthAndYearEvent(month, year)
        .then(json => {
            setLoading(false);
            downloadExcelFile(json.data.bytes, `DESPACHOS_${month}-${year}`);
        })
        .catch(err => {
            message.error(err.message);
            setLoading(false);
        });
    }
    
    return {
        loading, downloadExcel
    };
}